module.exports = __webpack_public_path__ + "img/logo-gif-markets.28339fa6.gif";